export const desktopUrls = new RegExp(
  /http(s)?:\/\/(www|us|test|ustest)?(\.)?asos(services)?\.(com|de|fr)(\/(es|it|au|ru|se|nl))?\//gi
);

export const desktopToMobile = (link, storeUrl) => {
  if (link && storeUrl) {
    link = link.replace(desktopUrls, storeUrl);
  }
  return link;
};



// WEBPACK FOOTER //
// ./helpers/links.js